import type {DecorationPlugin, DecorationSingleComponentPlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const stylePropertiesSingleComponentPlugin = {
    name: 'StylePropertiesPlugin',
    pack,
    unpack
} satisfies DecorationSingleComponentPlugin

export const stylePropertiesPlugin: DecorationPlugin = createPluginFromSingleComponentPlugin(
    stylePropertiesSingleComponentPlugin
)
